"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var webRequester_1 = require("../base/webRequester");
/**
 * @hidden
 */
var CreatorBase = /** @class */ (function (_super) {
    __extends(CreatorBase, _super);
    function CreatorBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorBase.prototype.setOptions = function (options) {
        if (options.accessToken !== undefined) {
            this.accessToken = options.accessToken;
        }
        if (options.companyNameKey !== undefined) {
            this.companyNameKey = options.companyNameKey;
        }
        this.creatorBaseUrl = options.creatorBaseUrl || this.creatorBaseUrl;
    };
    /**
     * @hidden
     */
    CreatorBase.prototype.setSettings = function (settings) {
        this.accessToken = settings.accessToken;
        this.companyNameKey = settings.companyNameKey;
        this.creatorBaseUrl = settings.creatorBaseUrl;
    };
    /**
     * @hidden
     */
    CreatorBase.prototype.getInitialSettings = function () {
        return {
            accessToken: null,
            companyNameKey: null,
            creatorBaseUrl: 'https://creator-server.attensi.com/api',
        };
    };
    /**
     * @hidden
     */
    CreatorBase.prototype.createInstance = function () {
        return axios_1.default.create({
            baseURL: this.creatorBaseUrl,
            headers: {
                common: {
                    'Authorization': 'Bearer ' + this.accessToken,
                    'company-name-key': this.companyNameKey,
                    'Content-Type': 'application/json',
                }
            }
        });
    };
    Object.defineProperty(CreatorBase.prototype, "accessToken", {
        /**
         * Get header 'Authorization'
         */
        get: function () {
            return this.settings.accessToken;
        },
        /**
         * Set header 'Authorization' to 'Bearer [accessToken]'
         */
        set: function (accessToken) {
            this.settings.accessToken = accessToken;
            if (accessToken) {
                this.instance.defaults.headers.common.Authorization = 'Bearer ' + this.settings.accessToken;
            }
            else {
                delete this.instance.defaults.headers.common.Authorization;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatorBase.prototype, "companyNameKey", {
        /**
         * Get header 'company-name-key'
         */
        get: function () {
            return this.settings.companyNameKey;
        },
        /**
         * Set header 'company-name-key' to '[companyNameKey]'
         */
        set: function (companyNameKey) {
            this.settings.companyNameKey = companyNameKey;
            if (companyNameKey) {
                this.instance.defaults.headers.common['company-name-key'] = this.settings.companyNameKey;
            }
            else {
                delete this.instance.defaults.headers.common['company-name-key'];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatorBase.prototype, "creatorBaseUrl", {
        /**
         * Get creator-server base url
         */
        get: function () {
            return this.settings.creatorBaseUrl;
        },
        /**
         * Set Get creator-server base url to '[creatorBaseUrl]'
         */
        set: function (creatorBaseUrl) {
            this.settings.creatorBaseUrl = creatorBaseUrl;
            this.instance.defaults.baseURL = this.settings.creatorBaseUrl;
        },
        enumerable: true,
        configurable: true
    });
    return CreatorBase;
}(webRequester_1.WebRequester));
exports.CreatorBase = CreatorBase;
//# sourceMappingURL=creatorBase.js.map